import CompanyTypeConfirmModal from '~/components/company-type-confirm/CompanyTypeConfirmModal';
import { CompanyTypeConfirmProvider } from '~/contexts/local';

export const CompanyTypeConfirm = () => {
  return (
    <CompanyTypeConfirmProvider>
      <CompanyTypeConfirmModal />
    </CompanyTypeConfirmProvider>
  );
};
